import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
    useGetEarningsQuery,
    useGetPlatformSettingsQuery,
} from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import { Payment } from '../../components/HostPayments/Payment';
import ErrorPage from '../ErrorPage';
import UserRole from '../../../shared/AuthRoles';
import { useSearchParams } from 'react-router-dom';

export const HostPaymentPage = () => {
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    useEffect(() => {
        if (!['owner_admin', 'admin'].includes(loggedInUser.role)) {
            navigate(`/permissionDenied`);
        }
    }, []);

    const { ownerId, year, month } = useParams();
    const [searchParams] = useSearchParams();

    const { data, isLoading } = useGetEarningsQuery({
        year: Number(year),
        month: Number(month),
        owner: Number(ownerId),
        projected: searchParams.get('projected') === 'true',
    });
    const { data: platformSettings } =
        useGetPlatformSettingsQuery('/platform-settings');

    return isLoading || !platformSettings ? (
        <LoadingComponent />
    ) : data && data.bills.length ? (
        <Payment
            payment={data.bills[0]}
            serviceFeePercentage={platformSettings.hostServiceFeePercentage}
        />
    ) : (
        <ErrorPage />
    );
};
